import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { GameService } from '../services/game.service';
import { Level } from '../_models/model';

@Injectable()
export class LevelResolver implements Resolve<Level[]> {
  constructor(private gameService: GameService, private readonly router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // TODO: redirect to error page on not found?
    return this.gameService.loadLevels();
  }
}
